import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const systemConfigurationRoute: InvariantJiraRoute = {
	name: 'system-configuration-general',
	path: '/jira/settings/system/general-configuration',
	exact: true,
};
